import { render, staticRenderFns } from "./ReportSales.vue?vue&type=template&id=c58d700e&scoped=true"
import script from "./ReportSales.vue?vue&type=script&lang=js"
export * from "./ReportSales.vue?vue&type=script&lang=js"
import style0 from "./ReportSales.vue?vue&type=style&index=0&id=c58d700e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c58d700e",
  null
  
)

export default component.exports